import { Card_CDN } from "../utils/images";

function MovieCard({movie}){
    
    
    if(movie===null) return;
    return(
        <div className="w-36 md:w-48 p-2 hover:scale-90 transition-transform duration-300">
            <img  alt="icon card" src={Card_CDN+movie}></img>


        </div>
    )
}
export default MovieCard
